import React from 'react';
import { Route, Redirect } from 'react-router';

import { CATEGORY_SLUGS } from 'src/landing-new/slugs';

import { BlogItem } from '../blog-item/blog-item';
import { Blog } from '../blog/blog';
import { PricingContainer as Pricing } from '../pricing/pricing-container';
import App from './app';
import BlackFridayCheckout from './black-friday';
import Checkout from './checkout';
import Report from './report';

// we have to pass the store into this function so we can extract user name from cookies
export default function getRoutes(store) {
  const AppWrapper = (props) => {
    return <App userName={store.getState().me.user_name} {...props} />;
  };

  return [
    <Route path="/" component={AppWrapper} />,
    <Route
      path="/blog"
      getComponent={(_, cb) => {
        cb(null, Blog);
      }}
    />,
    <Route
      path="/blog/(:categorySlug)/(:postSlug)"
      getComponent={(_, cb) => {
        cb(null, BlogItem);
      }}
    />,
    <Redirect from="/blog/(:categorySlug)" to="/blog" />,
    <Route
      path="/login"
      getComponent={(_, cb) => {
        import('./login').then((C) => {
          cb(null, C.default);
        });
      }}
    />,
    <Route
      path="/signup"
      getComponent={(_, cb) => {
        import('./signup').then((C) => {
          cb(null, C.default);
        });
      }}
    />,
    <Route
      path="/recover"
      getComponent={(_, cb) => {
        import('./recover').then((C) => {
          cb(null, C.default);
        });
      }}
    />,
    <Redirect from="/upgrade" to={'/checkout'} />,
    <Route
      path="/checkout"
      getComponent={(_, cb) => {
        cb(null, Checkout);
      }}
    />,
    <Route
      path="/black-friday"
      getComponent={(_, cb) => {
        cb(null, BlackFridayCheckout);
      }}
    />,
    <Route
      path="/pricing"
      getComponent={(_, cb) => {
        cb(null, Pricing);
      }}
    />,
    <Route
      path="/report/(:shortcode)"
      getComponent={(_, cb) => {
        cb(null, Report);
      }}
    />,
    <Route
      path="/edit/(:shortcode)"
      getComponent={(_, cb) => {
        import('./editor').then((C) => {
          cb(null, C.default);
        });
      }}
    />,
    <Route
      path="/thumbnail/(:shortcode)"
      getComponent={(_, cb) => {
        import('./thumbnail').then((C) => {
          cb(null, C.default);
        });
      }}
    />,
    <Route
      path="/clipper"
      getComponent={(_, cb) => {
        import('./clipper').then((C) => {
          cb(null, C.default);
        });
      }}
    />,

    ...CATEGORY_SLUGS.map((category) => (
      <Route path={`/${category}/(:view)`} component={App} />
    )),

    <Route
      path="/clipper/*"
      getComponent={(_, cb) => {
        import('./clipper').then((C) => {
          cb(null, C.default);
        });
      }}
    />,

    <Route path="/(:view)" component={App} />,
    <Route path="/(:view)/(:shortcode)" component={App} />,
    <Route path="/(:view)/(:shortcode)/(:version)" component={App} />,
  ];
}
